import { render, staticRenderFns } from "./gerenFuncionario.vue?vue&type=template&id=05642d22&scoped=true&"
import script from "./gerenFuncionario.vue?vue&type=script&lang=js&"
export * from "./gerenFuncionario.vue?vue&type=script&lang=js&"
import style0 from "./gerenFuncionario.vue?vue&type=style&index=0&id=05642d22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05642d22",
  null
  
)

export default component.exports